import { render, staticRenderFns } from "./DraggableItem.vue?vue&type=template&id=6365a1ff&scoped=true"
import script from "./DraggableItem.vue?vue&type=script&lang=ts"
export * from "./DraggableItem.vue?vue&type=script&lang=ts"
import style0 from "./DraggableItem.vue?vue&type=style&index=0&id=6365a1ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6365a1ff",
  null
  
)

export default component.exports